/* 🤖 this file was generated by svg-to-ts */
export const iconBloodUrea: {
  name: 'blood_urea';
  data: string;
} = {
  name: 'blood_urea',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M20.71 7l-1.42-1.43-2.83-2.83-1.41-1.42a1 1 0 00-1.41 0 1 1 0 000 1.42l.7.7L.91 16.88A3 3 0 003 22a3 3 0 002.12-.88L8 18.29l10.59-10.6.7.7A1 1 0 1020.71 7zm-9.2 4.95H8.69l7.07-7.07 1.41 1.41zM21 10s-3 3-3 5a3 3 0 006 0c0-2-3-5-3-5zm-1 6a1 1 0 111-1 1 1 0 01-1 1z"/></svg>`,
};
